<template>
    <section class="app-main">
        <div class="container is-fluid is-marginless app-content">
            <div class="columns head is-vcentered">
                <div class="column is-offset-3 is-6 has-text-centered">
                <h3 class="title is-size-3 has-text-weight-normal">Equipe volante et vacations</h3>
                </div>
                <div class="column is-3 is-hidden-mobile">
                <ol class="breadcrumb">
                    <li>
                    <a href="/#" class="is-active">Home</a>
                    </li>
                    <li>
                    <span class="active">Volant</span>
                    </li>
                </ol>
                </div>
            </div>
            <div class="animated">
                <div class="tile is-ancestor">
                    <div class="tile is-parent">
                        <article class="tile is-child box">
                            <div class="content">
                                <p>Pour faciliter la participation des personnes ayant des emplois du temps irréguliers qui auraient du mal à assurer un service le même jour toutes les 4 semaines, il existe un système dérogatoire, fonctionnant par vacations.</p>
                                <p>Faire partie de l'équipe volante permet de programmer ses services, on dira alors vacations. Les membres de cette équipe peuvent accumuler ainsi plusieurs vacations pour les “dépenser” plus tard. Autrement dit : on peut faire plus de services en amont pour ne pas revenir ensuite pendant une certaine période tout en conservant le droit de faire ses courses. En contrepartie d’une telle flexibilité, les membres de l’équipe volante participent pendant leurs périodes de disponibilité, exclusivement sur les créneaux en tension, quand La Louve a le plus de besoins. Certains créneaux ne sont jamais, ou très rarement, ouverts aux membres de l'équipe de volante.</p>
                                
                                <h2>Programmer des services</h2>

                                <p>
                                  Pour programmer leurs vacations, les membres de l'équipe volante doivent se connecter
                                  sur leur espace perso puis se rendre dans la rubrique
                                  <strong>« Service / Inscription »</strong>.
                                  L'inscription à des services se fait directement en ligne, en cliquant sur le service choisi.
                                </p>

                                <p>
                                  Si vous avez des difficultés de connexion à l'espace perso, vous pouvez vous inscrire
                                  en contactant le bureau des membres ou en y passant pendant les heures d'ouverture.
                                </p>

                                <p>
                                  La liste des places vacantes est générée chaque semaine, en fonction des places libres
                                  dans les équipes ABCD. Elle couvre 4 semaines (la semaine en cours + les 3 semaines suivantes).
                                  Un membre de l'équipe volante peut donc planifier ses vacations 4 semaines en amont, pas plus.
                                  Il ne peut pas effectuer plus de 2 vacations par jour.
                                </p>

                                <p>
                                  Les vacations pour les volants sont disponibles selon le principe du
                                  <strong>premier arrivé, premier servi</strong>.
                                  Sachez qu'il est très difficile, voire souvent impossible, de trouver une vacation
                                  quelques jours avant chaque décompte. Ne soyez pas la personne qui procrastine.
                                  Ne pas trouver de vacation juste avant le décompte n'est pas une excuse pour ne pas être à jour.
                                  L'équipe volante est conçue pour ceux qui sont prêts à planifier à l'avance.
                                </p>

                                <h2>Annuler un service</h2>

                                <p>
                                  Les membres de l'équipe volante peuvent annuler leur vacation sans pénalité jusqu'à la veille
                                  du service, uniquement auprès du bureau des membres, pendant les horaires d'ouverture,
                                  afin que le service annulé soit remis à disposition sur l'espace perso.
                                  On n'annule jamais les vacations auprès du coordinateur d'équipe.
                                </p>

                                <p>
                                  Manquer une vacation sans l'annuler entraîne le retrait d'un crédit de son compte
                                  d'épargne de service. Si on programme, puis manque plusieurs vacations, on peut perdre
                                  le droit d'en faire.
                                </p>

                                <p>
                                  Comme il s'agit d'un service programmé, les noms des membres de l'équipe volante
                                  qui se sont inscrits pour une vacation apparaissent au créneau choisi sur la feuille
                                  de présence, dans la rubrique <strong>« vacations »</strong>.
                                  Ces membres reportent leur numéro de coop et leur nom en arrivant et signent en partant,
                                  comme tout le monde.
                                </p>

                                <h2>Le décompte des vacations</h2>

                                <p>
                                  Comme tous les autres membres de La Louve, les membres de l'équipe volante doivent
                                  à la coopérative 13 services par an, tout en tenant compte de leur compteur qui doit
                                  être strictement positif le jour du décompte.
                                </p>

                                <p>
                                  Pour mieux comprendre le système de décompte de leurs vacations, on peut utiliser
                                  la métaphore du compte d'épargne-temps : on met de côté des vacations pour les dépenser
                                  plus tard. Le décompte fonctionne pour l'équipe volante comme un prélèvement mensuel.
                                  Le jour du décompte, le système informatique de La Louve retire une vacation du compte
                                  de chacun des membres de l'équipe volante concernée.
                                </p>

                                <p>
                                  Si le compte est strictement positif (≥ 1), tout va bien. S'il est à zéro
                                  (aucune vacation sur le compte) ou si sa valeur est négative, le membre doit
                                  2 rattrapages, comme n'importe quel membre d'une équipe ABCD.
                                </p>

                                <p>
                                  Il est donc important, pour les membres de l'équipe volante, de surveiller leur compte
                                  et d'effectuer avant le jeudi à 22h de leur semaine de décompte le nombre de vacations
                                  nécessaires afin de ne pas être en déficit.
                                </p>

                                <p>
                                  Il est de la responsabilité du membre de retenir les dates de décompte et de s'assurer
                                  que les services nécessaires sont effectués. Un mail de rappel est envoyé 12 jours avant
                                  le décompte pour vous aider, mais la responsabilité vous incombe.
                                  Si le mail se retrouve dans vos spams, si vous ne le voyez pas, si La Louve subit une panne
                                  informatique, vous êtes toujours tenu d'effectuer les services nécessaires à temps.
                                </p>

                                <p>
                                  Des calendriers indiquant les dates exactes des décomptes sont disponibles en ligne
                                  sur l'espace membre et au bureau des membres.
                                </p>

                                <h2>Les rattrapages</h2>

                                <p>
                                  À la différence des membres des équipes ABCD, les membres de l'équipe volante doivent
                                  programmer leurs rattrapages, sans exception, tout simplement en planifiant des
                                  vacations supplémentaires.
                                </p>

                                <p>
                                  <strong>Exemple :</strong> un membre de l'équipe volante qui n'avait aucune vacation sur
                                  son compte le jour de décompte doit 2 rattrapages. Son compte est donc débité de 2 points
                                  et affiche « -2 vacations ».
                                </p>

                                <p>
                                  Pour être à jour au prochain décompte, il a donc 4 semaines pour programmer et effectuer
                                  au moins 3 vacations : les 2 rattrapages + la vacation qu'il doit pour le cycle suivant
                                  de 4 semaines. Cela revient au même nombre de services qu'un membre d'une équipe ABCD
                                  effectuerait pour un service manqué.
                                </p>

                                <p>
                                  Un membre de l'équipe volante ne peut pas utiliser le même système de rattrapage que
                                  celui des équipes ABCD. S'il se présente à un service pour faire un rattrapage,
                                  le service ne sera pas validé.
                                </p>
                            </div>
                        </article>
                    </div>
                </div>
            
            </div>
        </div>
    </section>
</template>

<script>
export default {
  name: "Volant",
  data: function () {
    return {
      mesinfos: "",
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<style lang="css" scoped>
.is-title {
  text-transform: capitalize;
}

.subtitle:not(:last-child),
.title:not(:last-child) {
  margin-bottom: 1.5rem;
}

.title {
  color: #363636;
  font-size: 2rem;
  font-weight: 300;
  line-height: 1.125;
}

.level-item .subtitle,
.level-item .title {
  margin-bottom: 0;
}

.subtitle.is-5 {
  font-size: 1.25rem;
}

.subtitle {
  color: #2e2e2e;
  font-weight: 300;
  line-height: 1.25;
}

.subtitle strong {
  color: #363636;
}

.subtitle strong,
.title strong {
  font-weight: 500;
}

.level-item {
  /* -ms-flex-align: center; */
  align-items: center;
  /* display: -ms-flexbox; */
  display: flex;
  /* -ms-flex-preferred-size: auto; */
  flex-basis: auto;
  /* -ms-flex-positive: 0; */
  flex-grow: 0;
  /* -ms-flex-negative: 0; */
  flex-shrink: 0;
  /* -ms-flex-pack: center; */
  justify-content: center;
}

.breadcrumb {
  --separator: "\2044";
  list-style: none;
  /* -ms-flex-align: center; */
  align-items: center;
  /* display: -ms-flexbox; */
  display: flex;
  /* -ms-flex-pack: end; */
  justify-content: flex-end;
}

.level-left .level-item:not(:last-child),
.level-right .level-item:not(:last-child) {
  margin-right: 0.75rem;
}

.is-vertical-center {
  text-align: center;
  padding-top: 10px;
}
</style>
